import { render, staticRenderFns } from "./FileTypeRenderer.vue?vue&type=template&id=015e9792&"
import script from "./FileTypeRenderer.vue?vue&type=script&lang=js&"
export * from "./FileTypeRenderer.vue?vue&type=script&lang=js&"
import style0 from "./FileTypeRenderer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports